import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getparentsFeedbackAPi,deleteparentsFeedbackApi } from "../../../ApiUrl";
export const token = sessionStorage.getItem("accessToken")

const headers = {
    Authorization: `Bearer ${token}`,
};
// get parentsFeedback
export const getparentsFeedback = createAsyncThunk('getparentsFeedback/parentsFeedback', async () => {
    try {
        const response = await axios.get(`${getparentsFeedbackAPi}?limit=`, { headers });
        return response.data; 
    } catch (error) {
        throw new Error(error.message);
    }
});

// delete parentsFeedback
export const deleteparentsFeedbacks = createAsyncThunk('deleteparentsFeedbacks/parentsFeedback', async (parentsFeedbackid, { rejectWithValue }) => {
    try {
        const response = await axios.delete(`${deleteparentsFeedbackApi}/${parentsFeedbackid}`, { headers });
        return response.data._id; // Assuming your API response contains a 'parentsFeedbackid' property
    } catch (error) {
        return rejectWithValue(error.response.data.message);
    }
});



const parentsFeedbackSlice = createSlice({
    name: 'parentsFeedback',
    initialState: {
        parentsFeedbacks: [],
        status: 'idle',
        error: null,
        message: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            //getparentsFeedbacks
            .addCase(getparentsFeedback.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getparentsFeedback.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.parentsFeedbacks = action.payload;
            })
            .addCase(getparentsFeedback.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            })

            //delete parentsFeedbacks
            .addCase(deleteparentsFeedbacks.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(deleteparentsFeedbacks.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.parentsFeedbacks.data = state.parentsFeedbacks.data.filter(parentsFeedbacks => parentsFeedbacks.parentsFeedbackid !== action.payload);
                state.status = 'idle'
            })
            .addCase(deleteparentsFeedbacks.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });
    }
});

export default parentsFeedbackSlice.reducer;
